import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { useNavigate } from "react-router-dom";


import { useAuthContext } from "../../context/AuthContext";
import removeClientSideStorage from "../../utils/functions";

export default function SessionExpiredModal() {

  const { sessionExpired, expiryReason } = useAuthContext();
  const navigate = useNavigate();

  const handleLogin = () => {
    removeClientSideStorage();
    navigate('/login');
    window.location.reload();
  };
  
  return (
    <Modal open={sessionExpired} >
      <ModalDialog variant="outlined" role="alertdialog">
        <DialogTitle>
          <WarningRoundedIcon />
           {expiryReason === "inactivity" ? "Session Expired Due to Inactivity" : "Session Expired"}
        </DialogTitle>
        
        <Divider />
        <DialogContent sx={{width:400}}>
          {expiryReason === "inactivity" ? (
            <p>
              You were logged out due to 10 minutes of inactivity. Please sign in again to continue.
            </p>
          ) : (
            <p>Your session has expired. Please log in again.</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="solid"
            sx={{ backgroundColor: "#074c90" }}
            onClick={handleLogin}
          >
          Go to Login
          </Button>
          
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
}
